type LiveChatType = {
  fill: string
  width: string
  height: string
  title: string
}

function LiveChat(props: LiveChatType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'live chat'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 23 22'
      fill='none'
    >
      <title>{title}</title>
      <path
        d='M14.8542 1.39648H3.35417C2.29562 1.39648 1.4375 2.2546 1.4375 3.31315V10.5007C1.4375 11.5592 2.29562 12.4173 3.35417 12.4173H4.55208V16.7298L10.5417 12.4173H14.8542C15.9127 12.4173 16.7708 11.5592 16.7708 10.5007V3.31315C16.7708 2.2546 15.9127 1.39648 14.8542 1.39648Z'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M19.167 4.75H19.6462C20.7047 4.75 21.5628 5.60814 21.5628 6.66667V13.8542C21.5628 14.9127 20.7047 15.7708 19.6462 15.7708H18.4482V20.0833L12.4587 15.7708H10.542'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default LiveChat
